<template>
  <a-popover placement="bottomRight" overlayClassName="avatar-popover-overlay" :overlayStyle="overlayStyle">
    <template slot="content">
      <!-- avatar background: require('../../assets/drop-down_box_background.png') no-repeat -->
      <div style="min-width:200px; padding:15px 12px; display:flex; align-items:center;" :style="note">
        <div style="margin-right:10px;border-radius:50%; width:32px; height:32px; font-size:20px; text-align:center; overflow: hidden;" :style="{background: !userInfo.headImgUrl ? '#d1d1d1' : '#fff'}">
          <icon-font class="gb-icon-user" type="gb-icon-user" style="color: #fff;" v-if="!userInfo.headImgUrl" />
          <img :src="userInfo.headImgUrl" style="width:32px; height: 32px; display:block" v-else >
        </div>
        <div style="flex:1;min-width:0;">
          <div style="color:#1E1E28;font-size:14px;font-weight:bold;">{{ userInfo | userName }}</div>
          <div style="color:#484848;font-size:12px;display:flex;align-items:center;">
            <div style="flex:1;min-width:0;">{{ packageName }}</div>
            <div class="btn_login">
              <a style="margin-left:13px;color:#ffffff;" @click="handleMenuClick({ key:'user' })">
                {{ i18nRender('layouts.upgrade') }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- menu -->
      <a-menu
        mode="inline"
        :selectable="false"
        :inlineIndent="22"
        :openKeys.sync="openKeys"
        @click="handleMenuClick"
      >
        <a-menu-item key="home">
          <div style="display:flex; align-items:center; padding: 12px 0">
            <icon-font type="gb-icon-a-01" class="iconFont" />
            <div style="flex:1; min-width:0;">{{ i18nRender('layouts.usercenter') }}</div>
          </div>
        </a-menu-item>
        <a-menu-item key="accountSettings">
          <div style="display:flex; align-items:center; padding: 12px 0">
            <icon-font type="gb-icon-a-02" class="iconFont" />
            <div style="flex:1; min-width:0;">{{ i18nRender('layouts.accountSettings') }}</div>
          </div>
        </a-menu-item>
        <a-menu-item key="authority" v-if="menus.length">
          <div style="display:flex; align-items:center; padding: 12px 0">
            <icon-font type="gb-icon-a-03" class="iconFont" />
            <div style="flex:1; min-width:0;">{{ i18nRender('layouts.authority') }}</div>
          </div>
        </a-menu-item>
        <a-menu-item key="store" v-if="menus.length">
          <div style="display:flex; align-items:center; padding: 12px 0">
            <icon-font type="gb-icon-dianpu2" class="iconFont" />
            <div style="flex:1; min-width:0;">{{ i18nRender('layouts.store.authorization') }}</div>
          </div>
        </a-menu-item>
        <a-sub-menu key="syl">
          <span slot="title" style="display:flex; align-items:center; padding: 12px 0">
            <icon-font type="gb-icon-a-04" class="iconFont" />
            <div style="flex:1; min-width:0;">{{ i18nRender('layouts.menusyl') }}</div>
            <a-icon type="right" style="font-size:12px; transition:all 0.3s" :style="{transform: openKeys.includes('syl') ? `rotate(90deg)` : `rotate(0deg)`}" />
          </span>
          <a-menu-item style="display:flex; align-items:center; padding: 12px 0">
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{ i18nRender('layouts.menusyl.top') }}</span>
              </template>
              <div class="layout-syl-ob-item" @click.stop="$store.dispatch('entry/saveUseNewMenu', 2)">
                <a-icon type="check" v-if="useNewMenu === 2" />
                <img src="~@/assets/layout1.png" alt="">
              </div>
            </a-tooltip>
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{ i18nRender('layouts.menusyl.left') }}</span>
              </template>
              <div class="layout-syl-ob-item" @click.stop="$store.dispatch('entry/saveUseNewMenu', 1)">
                <a-icon type="check" v-if="useNewMenu === 1" />
                <img src="~@/assets/layout2.png" alt="">
              </div>
            </a-tooltip>

          </a-menu-item>
        </a-sub-menu>
        <a-menu-item key="logout">
          <div style="display:flex; align-items:center; padding: 12px 0">
            <icon-font type="gb-icon-a-05" class="iconFont" />
            <div style="flex:1; min-width:0;">{{ i18nRender('layouts.logout') }}</div>
          </div>
        </a-menu-item>
      </a-menu>
    </template>
    <div class="right-content__action">
      <icon-font class="gb-icon-user" type="gb-icon-user" v-if="!userInfo.headImgUrl"  />
      <img :src="userInfo.headImgUrl" style="width:22px; height: 22px; border-radius: 50%" v-else >
      <span style="margin-left:8px;">{{ userInfo | userName }}</span>
      <icon-font type="gb-icon-xiala" />
    </div>
  </a-popover>
</template>

<script>
import { i18nRender } from '@/locales'
import { USER_INFO } from '@/store/mutation-types'
import { mapGetters } from 'vuex'

export default {
  name: 'AvatarDropdown',
  data () {
    return {
      userInfo: this.$ls.get(USER_INFO),
      openKeys: [],
      note: {
        backgroundImage: 'url(' + require('../../assets/drop-down_box_background.png') + ')'
      }
    }
  },
  filters: {
    userName (userInfo) {
      return userInfo
        ? userInfo.userRealName || userInfo.realName || userInfo.nickName || userInfo.userName
        : '用户姓名'
    }
  },
  computed: {
    ...mapGetters(['useNewMenu', 'menus']),
    packageName () {
      const { systemCode } = this.$route.params
      const { microApps } = this.$store.getters
      const currentApp = systemCode === 'ERP'
        ? microApps.find(item => item.systemCode === 'ORDER_MANAGER')
        : microApps.find(item => item.systemCode === systemCode)

      return currentApp?.packageName || '-'
    },
    overlayStyle () {
      return {
      }
    }
  },
  methods: {
    i18nRender,
    handleMenuClick ({ key: action }) {
      console.log('action', action)
      if (this.$store.getters.isDemo) {
        this.$message.warning(this.$t('layouts.demo.tips'))
        return
      }
      this[action]()
    },
    user () {
      window.open('/#/company/serve/buy-serve')
    },
    home () {
      // window.open('/#/user/home')
      const { params: { serviceId, systemCode } } = this.$route
      this.$store.dispatch('entry/SetActiveAsync', {
        menuName: {
          zh_CN: '用户中心',
          en_US: 'User Center',
          ko_KR: '사용자 센터'
        },
        path: `/entry/${serviceId}/${systemCode}/sso-web#/embel/home`
      })
    },
    logout () {
      this.$confirm({
        title: i18nRender('logout.title'),
        content: i18nRender('logout.content'),
        okText: i18nRender('logout.okText'),
        okType: 'danger',
        cancelText: i18nRender('logout.cancelText'),
        onOk: () => {
          this.$store.dispatch('Logout')
        }
      })
    },
    authority () {
      const { params: { serviceId, systemCode } } = this.$route
      this.$store.dispatch('entry/SetActiveAsync', {
        menuName: {
          zh_CN: '权限管理',
          en_US: 'Authority',
          ko_KR: '권한 관리'
        },
        path: `/entry/${serviceId}/${systemCode}/sso-web#/embel/list`
      })
      // this.$store.dispatch('entry/SetActiveAsync', {
      //   menuName: {
      //     zh_CN: '购买'
      //   },
      //   key: 1111,
      //   external: true,
      //   verify: false,
      //   menuUrl: `http://localhost:9000/#/company/serve/buy-serve`
      // })
    },
    store () {
      this.$store.dispatch('entry/SetActiveAsync', {
        functionClass: 'SHOPAUTH_PLATFORM_AUTHORIZATION'
      })
    },
    accountSettings () {
      const { params: { serviceId, systemCode } } = this.$route
      this.$store.dispatch('entry/SetActiveAsync', {
        menuName: {
          zh_CN: '账号设置',
          en_US: 'Account Setting',
          ko_KR: '계정 설정'
        },
        path: `/entry/${serviceId}/${systemCode}/sso-web#/embel/basics-info`
      })
    }
  }
}
</script>

<style lang="less">
.avatar-popover-overlay {
  .ant-popover-arrow {
    top: -8px !important;
  }
  .ant-popover-inner-content {
    padding: 0;
    width: 240px;
    margin-top: -12px;
    position: relative;
  }
  .ant-menu-inline > .ant-menu-item, .ant-menu-submenu {
    // border-top: 1px #eee solid;
    &:hover {
      background: #e6f7ff;
    }
    &::after{
      display: none;
    }
  }
   .ant-menu-inline > .ant-menu-item:nth-child(n+5), .ant-menu-submenu {
    border-top: 1px #eee solid;
  }
  .ant-menu-inline > .ant-menu-item, .ant-menu-submenu, .ant-menu-submenu .ant-menu-submenu-title {
    height: auto !important;
    line-height: 22px !important;
    margin: 0 !important;
    padding: 0;
  }
  .ant-menu-submenu-arrow {
    display: none;
  }
  .ant-menu-sub:hover {
    .ant-menu-item {
      background: transparent !important;
    }
  }
  .layout-syl-ob-item {
    position: relative;
    margin-left: 10px;
    i {
      color: #5782F4;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -30%);
      font-size: 16px;
    }
  }
}
</style>

<style lang="less" scoped>
.right-content__action .gb-icon-user {
  display: inline-block;
  background: rgba(255,255,255,.2);
  border-radius: 50%;
  width: 22px;
  height: 22px;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
}
.iconFont {
  font-size: 17px !important;
}
.btn_login:hover {
  background: #007BFC;
}
.btn_login {
  width: 48px;
  height: 20px;
  background: linear-gradient(0deg, #A1A7C4 0%, #8B90AF 100%);
  border-radius: 10px;
}
</style>
